<div *ngIf="campos?.length > 0" class="root filtro-lista">
  <ng-container *ngFor="let campo of campos">
    <ng-container *ngIf="campo.valor">
      <div class="label filtro-lista-label">{{ campo.nome }}</div>
      <div class="filtro-lista-valor">{{ campo.valor }}</div>
    </ng-container>
  </ng-container>
</div>
